<template>
	<div class="right_body">
  <list-btn
  :listArr="listArr"
  :sdata="sdata"
  @detail="detail"
  @edit="edit"
  @add="add"
  @del="del"
  isAdd
  isEdit
  isDel
  >
  <span class="btn set_role" @click.stop="setSoleAuth"><i class="iconfont">&#xe66c;</i>设置角色权限</span>
  </list-btn>

  <tab-list
  :tabList="listArr"
  :total="total"
  :pages="pages"
  :fromData="fromData"
  :columns="tabColumns"
  tabName="system-auth-role"
  @currentChange="currentChange"
  @changePages="changePages"
  @selectSdata="selectSdata">
  </tab-list>



  <!-- 新增 -->
  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" v-dialogDrag>
    <el-form :model="roleFrom" :rules="rules" ref="roleFrom" label-width="90px">
      <el-form-item label="角色编码"  prop="roleCode">
        <el-input v-model="roleFrom.roleCode" autocomplete="off" :disabled="roleFrom.roleId ? true : false" maxlength="6"
        show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="角色名"  prop="roleName">
        <el-input v-model="roleFrom.roleName" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="角色类型" prop="roleType">
        <el-select v-model="roleFrom.roleType" @change="changeType" placeholder="请选择">
          <el-option label="集团" value="集团"></el-option>
          <el-option label="公司" value="公司"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="标识" prop="flag">
        <el-input v-model="roleFrom.flag" autocomplete="off"></el-input>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click.stop="submitForm" v-loading="$store.state.isLoading" :isDisable="isDisable">确 定</el-button>
    </div>
  </el-dialog>
	</div>
</template>

<script>
import {role} from 'api/auth.js'

import listBtn from 'components/btn/listBtn.vue';
import tabList  from 'components/table/list.vue';

export default{
	components:{listBtn,tabList},
	data() {
		return {
      isDisable:false,
			dialogFormVisible:false,
      dialogTitle:"",
			roleFrom:{},//提交信息
			sdata:{},
			listArr:[],
			isEdit:false,//状态
      typeTxt:"",
      rules:{
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change',
        }],
        roleCode:[{
          required: true,
          message: "请输入角色编码",
          trigger: "blur" ,
        },{
          pattern:/^[a-zA-Z0-9]+$/,
          message: "编码格式错误，只能输入数字或英文字母",
          trigger: "blur" ,
        }],
        roleName:[{
          required: true,
          pattern:/^[a-zA-Z0-9_\u4E00-\u9FA5]+$/,
          message: "请输入角色名",
          trigger: "blur" ,
        }]
      },
      tabColumns:[
        {field:"roleCode",title:"角色编码",width:100,"sortable":true},
        {field: 'roleName', title: '角色名', width:110},
        {field: 'roleType', title: '角色类型'},
      ],//表头字段
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:20,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				}
			}
		}
	},
	created(){
		this.getListArr();
	},
  updated:function(){

  },
	methods:{
		showErrorMsg(txt){
			this.$message.error(txt);
		},
    //选中数据
    selectSdata(data){
      this.sdata = data;
    },
    //当前页码改变
    currentChange(currentPage){
      this.fromData.page = currentPage;
      this.getListArr();
    },
    //页码条数改变
    changePages(pages){
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getListArr();
    },
    //类型改变
    changeType(val){
      this.roleFrom.roleType = val
    },
		//获取列表
		async getListArr(){
			let res = await this.$post(role.list,this.fromData);
      if(res.status && res.data){
        this.listArr = res.data.list;
        this.pages = res.data.pages;
        this.total = res.data.total;
      }else{
        this.listArr = [];
        this.total = 0;
        this.pages = 0;
      }
		},
    //搜索
    subSearch(){
      this.getlistArr();
    },
		//详情
		detail(){
			if(!this.sdata.supplierId){
				this.$message.error('请选择要查看的');
				return;
			}
			this.$router.push({name:'base-supplier-detail',params:{id:this.sdata.supplierId}});
		},
		//新增
		add(){
      this.dialogTitle = "新增角色";
      this.isEdit = false;
      this.roleFrom = {};
			this.dialogFormVisible = true;
		},
		//编辑
		edit(){
      this.dialogTitle = "编辑角色";
      this.isEdit = true;
			if(!this.sdata.roleId){
				this.$message.error('请选择要编辑的数据');
				return;
			}
      this.dialogFormVisible = true;
      this.roleFrom = JSON.parse(JSON.stringify(this.sdata));
		},
		//删除
		del(){
			if(!this.sdata.roleId){
				this.$message.error('请选择要删除的数据');
				return;
			};
      this.$confirm('确定删除么, 是否继续?', '提示', {
      	confirmButtonText: '确定',
      	cancelButtonText: '取消',
      	type: 'warning'
      })
      .then(async () => {
      	let res = await this.$post(role.delete,{roleId:this.sdata.roleId});
      	const {data,msg,status} = res;
      	if(status){
      		this.listArr[this.sdata.index] = this.sdata;
          this.$message.success(msg);
          this.getListArr()
      	}else{
      		this.$message.error(msg);
      	}
      })

			/*	 */
		},
    //设置角色权限
    setSoleAuth(){
      if(!this.sdata.roleId){
      	this.$message.error('请选择需要设置的角色');
      	return;
      }
      this.$router.push({name:'system-role-auth',params:{id:this.sdata.roleId}});
    },
    //提交
    submitForm(){
      let vm = this;
      this.$refs['roleFrom'].validate(async (vaild)=>{
        if(vaild){
          let postUrl = role.add;
          if(this.isEdit) postUrl = role.modify;
          this.isDisable = true;
          //console.log(this.roleFrom)
          let res = await this.$post(postUrl,this.roleFrom);
          if(res.status){
            this.$message.success(res.msg);
            this.roleFrom = {
              type:2,
              status:1
            };
            this.dialogFormVisible = false;
            this.getListArr();
          }else{
            this.$message.error(res.errorMsg);
          }
        }else{
          return false;
        }
      });
    }


	}
}
</script>

<style>
</style>
